// This turns links on content blocks into clickable blocks that are accessibility friendly.

function linkBoxes() {

    var boxes = document.querySelectorAll('.blockLink');
  
    boxes.forEach(function (box) {
      var link = box.querySelector('a');
      if (link) {
        var url = link.getAttribute('href');
        box.addEventListener('click', function () {
          location.href = url;
          link.preventDefault;
        });
        box.classList.add('linkify');
        link.addEventListener('focus', function () {
          box.classList.add('isfocused');
        });
        link.addEventListener('blur', function () {
          box.classList.remove('isfocused');
        });
  
   /* Inject CTA in to cards as visual affordance but hide from assistive tech announcements */
       // box.insertAdjacentHTML('beforeend', '<span class="blockLink-cta" aria-hidden="true">{{ __("Learn more", "duc") }}</span>');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    if ('querySelector' in document) {
      linkBoxes();
    }
  });
  




  function linkBoxesCTA() {

    var boxes = document.querySelectorAll('.blockLinkCTA');
  
    boxes.forEach(function (box) {
      var link = box.querySelector('a');
      if (link) {
        var url = link.getAttribute('href');
        box.addEventListener('click', function () {
          location.href = url;
          link.preventDefault;
        });
        box.classList.add('linkify');
        link.addEventListener('focus', function () {
          box.classList.add('isfocused');
        });
        link.addEventListener('blur', function () {
          box.classList.remove('isfocused');
        });

      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    if ('querySelector' in document) {
      linkBoxesCTA();
    }
  });
  


// WEBPACK FOOTER //
// ./src/js/vanilla/linkBoxes.js